import React, { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaCheckCircle } from "react-icons/fa";
import './Auth.css';
import GuideWell_Blue from '../Assets/RSIDE.png';
import buildingImg from '../Assets/building_manager.jpg';

const BASE_URL = 'https://api.rside.app';

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const roleRes = await fetch(`${BASE_URL}/CheckUserRole?email=${encodeURIComponent(formData.email)}`);
      const rawRole = await roleRes.text();
      let role = '';
      try {
        const parsed = JSON.parse(rawRole);
        role = (typeof parsed === 'string'
          ? parsed
          : (parsed?.role || parsed?.Role || parsed?.user_type || parsed?.UserType || '')).toString().toLowerCase().trim();
      } catch {
        role = rawRole.replace(/"/g, '').trim().toLowerCase();
      }
      if (role === 'tenant' || role === 'renter') {
        setError('This portal is for property managers only. Please use the tenant login.');
        setLoading(false);
        return;
      }
      await signInWithEmailAndPassword(auth, formData.email, formData.password);
      fetch(`${BASE_URL}/setLastLogin?email=${encodeURIComponent(formData.email)}`, { method: 'PUT' }).catch(() => {});
      navigate("/home");
    } catch (err) {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="auth-container auth-bg-full">
      <img src={buildingImg} alt="" className="auth-full-bg-img" />
      <div className="auth-full-overlay" />

      <div className="auth-inner">
      {/* Left branding */}
      <div className="auth-brand-side">
        <h1 className="auth-brand-tagline">Welcome back.</h1>
        <p className="auth-brand-sub">Your properties are waiting. Pick up right where you left off.</p>
        <ul className="auth-brand-features">
          <li><FaCheckCircle className="auth-feature-icon" /> Track rent &amp; payments</li>
          <li><FaCheckCircle className="auth-feature-icon" /> Manage work orders</li>
          <li><FaCheckCircle className="auth-feature-icon" /> Monitor vacancies</li>
          <li><FaCheckCircle className="auth-feature-icon" /> Communicate with tenants</li>
        </ul>
      </div>

      <div className="auth-full-card-wrap">
        <div className="auth-card auth-dark-card">
          <img src={GuideWell_Blue} alt="RSIDE" className="auth-GuideWell_Blue" />

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group password-group">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                className="form-input"
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {error && <p style={{ color: '#ef4444', fontSize: 13, margin: '0 0 4px', textAlign: 'center' }}>{error}</p>}

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Logging in…' : 'Log In'}
            </button>
          </form>

          <div className="auth-links">
            <p>
              Don't have an account? <Link to="/signup">Sign Up</Link>
            </p>
            <p>
              <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>
            </p>
            <p>
              <Link to="/select-role?mode=login" className="forgot-password">← Back</Link>
            </p>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default Login;
